import React, { useState, useEffect } from "react";
import { getAllClient } from "../../../Services/Superadmin/Superadmin";
import { UpdateRefferPrice, getReferClients } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";
import Table from "../../../Utils/Table/Table";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { useFormik } from "formik";
import { getUserFromToken } from "../../../Utils/TokenVerify";

const Basicsetting = () => {
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage] = useState(10);
  const [ranges, setRanges] = useState({
    range1: "",
    range2: "",
    range3: "",
    range4: "",
  });

  const columns = [
    { Header: "UserName", accessor: "UserName" },
    { Header: "Password", accessor: "password" },
    {
      Header: "Referred By",
      accessor: "referred_by",
      Cell: ({ cell }) => {
        return cell.value
          ? cell.value === TokenData.user_id
            ? "ADMIN"
            : "USER"
          : "N/A";
      },
    },
    {
      Header: "Referral Price",
      accessor: "referral_price",
      Cell: ({ cell }) => cell.value,
    },
    {
      Header: "Status",
      accessor: "isActive",
      Cell: ({ cell }) => (cell.value ? "Active" : "Inactive"),
    },
    {
      Header: "Referral Point",
      accessor: "isPaymentDone",
      Cell: ({ cell }) => (cell.value ? "Paid" : "Unpaid"),
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      Cell: ({ cell }) => fDateTimesec(cell.value),
    },
  ];

  const getallclient = async () => {
    try {
      const data = { userid: user_id };
      const response = await getAllClient(data);
      if (response.status) {
        setRanges({
          range1: response?.data?.Range1 || "",
          range2: response?.data?.Range2 || "",
          range3: response?.data?.Range3 || "",
          range4: response?.data?.Range4 || "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getsignupuser = async () => {
    try {
      const admin_id = TokenData?.user_id;
      const response = await getReferClients({ admin_id });

      const searchfilter = response.data?.filter((item) => {
        const searchInputMatch =
          search === "" ||
          (item.UserName &&
            item.UserName.toLowerCase().includes(search.toLowerCase()));
        return searchInputMatch;
      });

      setData(search ? searchfilter : response.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getallclient();
  }, []);

  useEffect(() => {
    getsignupuser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const Update_RefferPrice = async (Range1, Range2, Range3, Range4) => {
    try {
      const data = { userId: user_id, Range1, Range2, Range3, Range4 };
      const response = await UpdateRefferPrice(data);
      if (response.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.message,
          timer: 5000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.message,
          timer: 5000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      range1: ranges.range1,
      range2: ranges.range2,
      range3: ranges.range3,
      range4: ranges.range4,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      Update_RefferPrice(
        values.range1,
        values.range2,
        values.range3,
        values.range4
      );
    },
  });

  return (
    <div
      className="container-fluid "
    
    >
      <div className="row justify-content-center">
        <div className="col-xl-12 col-lg-12">
          <div className="card shadow-sm border-0 rounded-4">
            {/* HEADER */}
            <div className="card-header border-0 bg-white rounded-top-4 px-4 pt-3 pb-2 d-flex flex-wrap justify-content-between align-items-center">
              <div>
                <h4 className="card-title mb-1 d-flex align-items-center gap-2">
                  Refer &amp; Earn
                  <span
                    className="text-primary"
                    style={{ cursor: "help", fontSize: "18px" }}
                    title="Set referral bonuses based on user deposit ranges. Example: If you set $10 for the 50–99 range, when a referred user deposits between $50 and $99, you earn $10."
                  >
                    ℹ️
                  </span>
                </h4>
                <p className="text-muted small mb-0">
                  Configure referral earnings for different deposit ranges and
                  view referred users.
                </p>
              </div>
            </div>

            <hr className="mt-0 mb-0" />

            {/* BODY */}
            <div className="card-body px-4 pb-4 pt-4">
              <div className="row g-4">
                {/* LEFT: REFERRAL RANGES FORM */}
                <div className="col-xl-5 col-lg-6">
                  <div className="border rounded-3 h-100 p-3">
                    <h6 className="mb-3 fw-semibold">Referral Bonus Settings</h6>
                    <form onSubmit={formik.handleSubmit}>
                      <div className="mb-3">
                        <label className="form-label fw-bold" htmlFor="range1">
                          Earn ($) when user deposits between 50 and 99
                        </label>
                        <input
                          id="range1"
                          type="number"
                          className="form-control"
                          placeholder="Enter value for 50 < 100"
                          {...formik.getFieldProps("range1")}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-bold" htmlFor="range2">
                          Earn ($) when user deposits between 100 and 499
                        </label>
                        <input
                          id="range2"
                          type="number"
                          className="form-control"
                          placeholder="Enter value for 100 < 500"
                          {...formik.getFieldProps("range2")}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-bold" htmlFor="range3">
                          Earn ($) when user deposits between 500 and 999
                        </label>
                        <input
                          id="range3"
                          type="number"
                          className="form-control"
                          placeholder="Enter value for 500 < 1000"
                          {...formik.getFieldProps("range3")}
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-bold" htmlFor="range4">
                          Earn ($) when user deposits 1000 or more
                        </label>
                        <input
                          id="range4"
                          type="number"
                          className="form-control"
                          placeholder="Enter value for ≥ 1000"
                          {...formik.getFieldProps("range4")}
                        />
                      </div>

                      <div className="d-flex justify-content-start mt-2">
                        <button
                          className="btn btn-primary px-4"
                          type="submit"
                        >
                          Save Settings
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* RIGHT: REFERRED USERS TABLE */}
                <div className="col-xl-7 col-lg-6">
                  <div className="border rounded-3 h-100 p-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0 fw-semibold">Referred Users</h6>
                    </div>

                    <div className="mb-3">
                      <label className="form-label small mb-1">
                        Search by username
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Type a username to filter..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>

                    <div className="flex-grow-1">
                      <Table
                        columns={columns}
                        data={data || []}
                        rowsPerPage={rowsPerPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FOOTER (OPTIONAL) */}
            {/* <div className="card-footer bg-white border-0 text-end px-4 pb-3">
              <small className="text-muted">
                Changes take effect immediately for new referrals.
              </small>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Basicsetting;
